export default __webpack_public_path__ + "assets/images/2c32a4e641560dcf98200337d61572ed.png";